import React from 'react';
import { Icon } from 'src/components/Icons';

export interface IPortalDeadlineDate {
  date: string;
  className?: string;
}

export const DeadlineDate = ({
  date,
  className,
  ...rest
}: IPortalDeadlineDate) => {
  return (
    <span className={className} {...rest}>
      <Icon type="clock" aria-label="" data-testid="clock-icon" />{' '}
      <span>{date}</span>
    </span>
  );
};
